import React, { Component } from "react";
import Tooltip from "blob_types/blobhub/compute/workflow/controls/common/tooltip";

/**
 * ThreadItemAction — the small icon button in a thread item's action bar.
 *
 * Briefly swaps to a "confirmed" icon after activation, because the actions it carries are mostly
 * invisible: `Clipboard.to` has no visible side-effect of its own, so without the swap a click is
 * indistinguishable from a miss.
 *
 * Extracted from the thread widget so the Mission Control cell view uses the same control rather
 * than a lookalike. Its styling comes from `.playground-thread-action`, alongside the rest of the
 * thread vocabulary.
 *
 * Props: tooltip · confirmTooltip · icon · confirmIcon · onActivate
 */
export default class ThreadItemAction extends Component {
  constructor(props) {
    super(props);
    this.state = { confirmed: false };
    this.timer = null;
  }

  componentWillUnmount() {
    if ( this.timer ) clearTimeout(this.timer);
  }

  handleClick = () => {
    if ( this.props.onActivate ) this.props.onActivate();
    if ( this.props.confirmIcon ) {
      this.setState({ confirmed: true });
      if ( this.timer ) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ confirmed: false });
        this.timer = null;
      }, 1200);
    }
  }

  render() {
    const showConfirm = this.state.confirmed && this.props.confirmIcon;
    return (
      <Tooltip text={showConfirm ? (this.props.confirmTooltip || this.props.tooltip) : this.props.tooltip}>
        <button
          type="button"
          className="playground-thread-action"
          // The button's only visible content is an icon, so without this it has no accessible
          // name at all — invisible to a screen reader and unaddressable by a test.
          aria-label={this.props.tooltip}
          onClick={this.handleClick}
        >
          {showConfirm ? this.props.confirmIcon : this.props.icon}
        </button>
      </Tooltip>
    );
  }
}
